webpackJsonp([64],{

/***/ "ErNr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SubscriptionInvoiceHistoryContainer = (function () {
    SubscriptionInvoiceHistoryContainer.$inject = ["TranslateSvc"];
    function SubscriptionInvoiceHistoryContainer(TranslateSvc) {
        this.TranslateSvc = TranslateSvc;
    }
    SubscriptionInvoiceHistoryContainer.prototype.$onChanges = function () {
        if (this.apiErrorMessage) {
            var error = this.apiErrorMessage.toLocaleLowerCase();
            this.apiErrorMessage = this.TranslateSvc.has(error) ? this.TranslateSvc.get(error) : error;
        }
    };
    return SubscriptionInvoiceHistoryContainer;
}());
angular.module('animatronApp.SubscriptionInvoiceHistoryContainer', [])
    .component('subscriptionInvoiceHistoryContainer', {
    bindings: {
        loadingDetails: '<',
        cardDetails: '<',
        apiErrorMessage: '<'
    },
    controller: SubscriptionInvoiceHistoryContainer,
    templateUrl: __webpack_require__("jGt4")
});


/***/ }),

/***/ "jGt4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-invoice-history-container_f2302383f0fcfd294127ccb395d0aaf3.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/64-bd880478516a225297ea.min.js